export const onDemandImage = 'https://storage.googleapis.com/jakroo/homepage/on_demand_image.jpg'
export const onDemandSavings = 'https://storage.googleapis.com/jakroo/homepage/OnDemand_Price_chart.png'
export const batchSavings = 'https://storage.googleapis.com/jakroo/homepage/Dynamic_Price_Chart.png'
export const fixedSavings = 'https://storage.googleapis.com/jakroo/homepage/Custom_Price_Chart.png'
export const fixedBadge = 'https://storage.googleapis.com/jakroo/homepage/custom_price_Icon.jpg'
export const fixedImage = 'https://storage.googleapis.com/jakroo/homepage/custom_price_image.png'
export const batchImage = 'https://storage.googleapis.com/jakroo/homepage/dynamic_store_image.jpg'

export const onDemandMessagesReseller = [
  'idealForRecurring',
  'individualCheckout',
  'directDropShipping',
  'individualDiscounting',
  'turnaroundDays',
  'twentyFourSeven',
  'realTimeProduction'
]

export const fixedDateMessagesReseller = [
  'idealForLarger',
  'individualCheckout',
  'dropOrBulkShipping',
  'saveWithGroup',
  'turnaroundDays',
  'customOrderingWindow',
  'bulk'
]

export const customPriceMessagesReseller = [
  'idealForEvents',
  'individualCheckout',
  'dropOrBulkShipping',
  'fixedPricing',
  'turnaroundDays',
  'customOrderingWindow',
  'bulk'
]


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamStoreCards/constants.ts